import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';
import { S as StateOptions } from './state-options.js';
import { n as numberOnlyHandler } from './utils5.js';
import { d as defineCustomElement$5 } from './custom-popper2.js';
import { d as defineCustomElement$4 } from './form-control-error-text2.js';
import { d as defineCustomElement$3 } from './form-control-select2.js';
import { d as defineCustomElement$2 } from './form-control-text2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const IdentityAddressForm = /*@__PURE__*/ proxyCustomElement(class IdentityAddressForm extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.inputHandler = (name, value) => {
            this.address[name] = value;
            this.address = Object.assign({}, this.address);
        };
        this.handleFormUpdate = undefined;
        this.errors = undefined;
        this.defaultValues = undefined;
        this.address = {};
    }
    handleAddressChange(newValues) {
        this.handleFormUpdate(newValues);
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        return (h(Host, { key: '5d9d020cdb5f9e0c422098f82fbd9b1c237515f2', exportparts: "label,input,input-invalid" }, h("div", { key: '280b3308698d51c8f3e60124f0433e12ff585abe', class: "row gy-3" }, h("div", { key: 'c31ef56c52561e2acaed2dac868117f6171a09cb', class: "col-12 col-md-8" }, h("form-control-text", { key: 'a53eb44a3b6ab0044ba1746025293fa5be1cd469', name: "line1", label: "Street Address", defaultValue: (_a = this.defaultValues) === null || _a === void 0 ? void 0 : _a.line1, errorText: (_b = this.errors) === null || _b === void 0 ? void 0 : _b.line1, inputHandler: this.inputHandler, helpText: "\u200B\u200BEnter your address exactly as stated on your driver's license. No PO Boxes." })), h("div", { key: 'cd62d3f1ea062f67ab71ced663954b172fa3c4ed', class: "col-12 col-md-4" }, h("form-control-text", { key: '24b4e359217b92c9d010c23f0a670f32a969c36e', name: "line2", label: "Apartment, Suite, etc. (optional)", defaultValue: (_c = this.defaultValues) === null || _c === void 0 ? void 0 : _c.line2, errorText: (_d = this.errors) === null || _d === void 0 ? void 0 : _d.line2, inputHandler: this.inputHandler })), h("div", { key: '5e2cf9ef49d42c736d8004e5063377a962857b35', class: "col-12" }, h("form-control-text", { key: 'b408fca949adc1e1f96ad1ab01d8265ef427cd18', name: "city", label: "City", defaultValue: (_e = this.defaultValues) === null || _e === void 0 ? void 0 : _e.city, errorText: (_f = this.errors) === null || _f === void 0 ? void 0 : _f.city, inputHandler: this.inputHandler })), h("div", { key: 'ab8c048e274784406a8a872650e68791d3aa5844', class: "col-12 col-md-6" }, h("form-control-select", { key: '76db258faf7a4b30f7f1b6c6e975e5ea7e7c61d6', name: "state", label: "State", defaultValue: (_g = this.defaultValues) === null || _g === void 0 ? void 0 : _g.state, options: StateOptions, errorText: (_h = this.errors) === null || _h === void 0 ? void 0 : _h.state, inputHandler: this.inputHandler })), h("div", { key: '8bd2661ad3e579a52f91ce58c6be680d9955584b', class: "col-12 col-md-6" }, h("form-control-text", { key: 'd8a2f3552e25bc57d8f09e61ee78f7f5a33e4bc7', name: "postal_code", label: "Postal Code", defaultValue: (_j = this.defaultValues) === null || _j === void 0 ? void 0 : _j.postal_code, errorText: (_k = this.errors) === null || _k === void 0 ? void 0 : _k.postal_code, maxLength: 5, keyDownHandler: numberOnlyHandler, inputHandler: this.inputHandler })), h("div", { key: '93be2db05699edaa12981e0d96a9626ecc169030', class: "col-12" }, h("form-control-select", { key: '5f99c15b72cec36dc3b895c4dadce328f4503f6a', name: "country", label: "Country", options: [{ label: 'United States', value: 'USA' }], inputHandler: this.inputHandler, defaultValue: (_l = this.defaultValues) === null || _l === void 0 ? void 0 : _l.country, errorText: (_m = this.errors) === null || _m === void 0 ? void 0 : _m.country,
            // just for now so we skip handling country specificities
            disabled: true })))));
    }
    static get watchers() { return {
        "address": ["handleAddressChange"]
    }; }
}, [0, "justifi-identity-address-form", {
        "handleFormUpdate": [16],
        "errors": [8],
        "defaultValues": [8, "default-values"],
        "address": [32]
    }, undefined, {
        "address": ["handleAddressChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-identity-address-form", "custom-popper", "form-control-error-text", "form-control-select", "form-control-text", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-identity-address-form":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, IdentityAddressForm);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "form-control-error-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "form-control-select":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "form-control-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { IdentityAddressForm as I, defineCustomElement as d };
